const toArray = (value) => {
    if (Array.isArray(value)) return value;
    if (value == null || value === "") return [];
    return [value];
};

export const escapeGridifyValue = (value) =>
    String(value ?? "").replace(/([(),|\\]|\/i)/g, "\\$1");

export const buildQuestionFilter = ({
    title = "",
    QCode = "",
    tags,
    tag,
} = {}) => {
    const filters = [];
    const normalizedTitle = String(title).trim();
    const selectedTags = toArray(tags ?? tag)
        .map((value) => String(value).trim())
        .filter(Boolean);

    if (normalizedTitle) {
        filters.push(`title=*${escapeGridifyValue(normalizedTitle)}/i`);
    }
    if (QCode !== "" && QCode != null) {
        filters.push(`qCode=${QCode}`);
    }

    selectedTags.forEach((value) => {
        filters.push(`tags=${escapeGridifyValue(value)}`);
    });

    return filters.join(",");
};
